<template>
  <div class="accordion__fullscreen accordion__fullscreen--wrapper" @full-screen-accordion-click="handleItemClick">
    <slot></slot>
  </div>
</template>

<script>
  import Vue from 'vue';

  export default {
    name: 'FullScreenAccordion',
    props: [
      'value'
    ],
    data(){
      return {
        activeItem: this.value,
        bus: new Vue()
      }
    },
    provide() {
      return {
        fullScreenAccordion: this
      };
    },
    methods: {
      handleItemClick
    },
    watch: {
      value() {
        this.activeItem = this.value;
      }
    },
    beforeMount() {
      this.bus.$on('fullScreenAccordionClick', this.handleItemClick);
    }
  }

  //////////

  function handleItemClick(name) {
    this.activeItem = name;
    this.$emit('input', name);
    this.$emit('change', name);
  }
</script>

<style lang="scss" scoped>

</style>
